export default "__VITE_ASSET__Dz6ndInK__"